import { useState } from "react";
import { addClub, addMeeting } from "../../js/database";

export function AddClub({user}) {
    return (
        <div class="modal fade" id="addClub" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
<div class="modal-dialog">
<div class="modal-content bg-dark">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Add Club</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <p>The club must already be officially registered with Mr. Bruno to be approved.</p>
    <form onSubmit={(e) => {
      e.preventDefault();
      var club = e.target[0].value;
      var color = e.target[1].value;
      addClub(user.uid, club, color).then((c) => {

      })


    }}>
    <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Club Name:</label>
    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="club"/>
    </div>
    <div>
    <label for="club">Color:</label>
      <input type="color" className="form-control" id="club" name="club" defaultValue="#000000"/>
    </div>
    <button type="submit" class="btn btn-primary mt-4" data-bs-dismiss="modal">Add</button>
    </form>
    </div></div></div></div>
    )
}

export function AddMeeting({clubName}) {
    const [type , setType] = useState("");

    return (
        <form onSubmit={(e) => {
           

        }}>
  <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Type:</label>
    <select class="form-select" aria-label="Default select example" onChange={(e) => {
        setType(e.target.value);
    }}>
  <option selected>Open this select menu</option>
  <option value="weekly">Weekly</option>
  <option value="cyclic">Cyclic</option>
  <option value="one-time">One Time</option>
</select>
  </div>
  <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Day:</label>
    {type === "weekly" ? <select class="form-select" aria-label="Default select example" id="meetingDay">
    <option selected>Open this select menu</option>
    {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((d, i) => (
        <option value={i}>{d}</option>
    ))}
    </select> : type === "cyclic" ? 
    <select class="form-select" aria-label="Default select example" id="meetingDay">
  <option selected>Open this select menu</option>
    {Array.from({length: 8}, (_, i) => i).map((d, i) => (
        <option value={i}>Day {d+1}</option>
    ))}
    </select> : type === "one-time" ? 
    <input type="date" class="form-control" id="meetingDay"/> :
     <p>Select a type</p>}
    </div>
    <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Start Time:</label>
    <input type="time" class="form-control" id="meetingStart"/>
    </div>
    <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">End Time:</label>
    <input type="time" class="form-control" id="meetingEnd"/>
    </div>
    <button type="button" onClick={() => {
         var day = document.getElementById("meetingDay").value;
            var start = document.getElementById("meetingStart").value;
              var end = document.getElementById("meetingEnd").value;
              addMeeting(clubName, type, day, start, end).then((m) => {
                //  window.location.reload();
              })
    }} class="btn btn-primary mt-4">Add</button>



  
  </form>
    )
}
